{
  "name": "Project name",
  "new_project": "New project",
  "name_placeholder": "Name of the project",
  "client": "Client",
  "client_placeholder": "Name of the client",
  "agency": "Agency",
  "agency_placeholder": "Name of the agency",
  "defaultFPS": "Default FPS",
  "agency_defaultFPS": "Default FPS of the project",
  "shootingDays": "Shooting days",
  "agency_shootingDays": "Number of shooting days",
  "due_date": "Due date",
  "update_project": "Update project",
  "fps": "Default project frame rate",
  "fps_tooltip": "Defines the fps for newly created shots"
}
